import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import {
    IonPage,
    IonContent,
    IonCard,
    IonCardContent,
    IonButton,
    IonLabel,
    IonItem,
    IonRadioGroup,
    IonRadio,
    IonText,
    IonAlert,
    IonModal,
} from "@ionic/react";

interface QuestionData {
    title: string;
    content: string;
    questions: QuestionSubData[];
}

interface QuestionSubData {
    questionText: string;
    correctAnswer: string;
    options: string[];
}

interface Props {
    onComplete?: () => void;
}

const Comprehension: React.FC<Props> = ({ onComplete }) => {
    // Dynamic story and questions

    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [selectedOption, setSelectedOption] = useState<string | null>(null);
    const [showImage, setShowImage] = useState(false);
    const [questions, setQuestions] = useState<QuestionData[]>([]);
    const [userAnswer, setUserAnswer] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [error, setError] = useState(false);
    const modal = useRef<HTMLIonModalElement>(null);

    const shuffleArray = (array: any[]) => {
        for (let i = array.length - 1; i > 0; i--) {
            const randomIndex = Math.floor(Math.random() * (i + 1));
            [array[i], array[randomIndex]] = [array[randomIndex], array[i]];
        }
        return array;
    };

    // Handle Submit Answer
    const handleSubmit = (selectedOption: any) => {
        setSelectedOption(selectedOption)
        if (selectedOption === questions[currentIndex]?.questions[currentQuestionIndex].correctAnswer) {

            if (currentQuestionIndex < questions[currentIndex]?.questions.length - 1) {
                setTimeout(() => {
                    setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
                }, 1000); // Delay reduced to 3 seconds
            } else {
                setShowImage(true);
                console.log(currentIndex);
                onComplete?.()
                setTimeout(() => {
                    if (currentIndex === questions.length - 1) {
                        setCurrentIndex(0);
                        fetchQuestions();
                    }
                    else {
                        setCurrentIndex(currentIndex + 1);
                    }
                    setError(false);
                    setCurrentQuestionIndex(0);
                    setShowImage(false);
                }, 5000); // Delay reduced to 3 seconds
            }
            setUserAnswer('');
        }
    };

    const fetchQuestions = async () => {
        try {
            let data: QuestionData[] = [];

            if (process.env.REACT_APP_DEVELOPMENT !== 'WEB') {
                const response = await fetch(process.env.REACT_APP_API_URL + 'ClassThreeEnglish/ReadingComprehension.json');
                data = await response.json();
            } else {
                const module = await import('../../../datas/ClassThreeEnglish/ReadingComprehension.json');
                data = module.default;
            }

            const shuffledQuestions = shuffleArray(data);
            setQuestions(shuffledQuestions);
        } catch (error) {
            console.error('Error loading data:', error);
        }
    };

    useEffect(() => {
        fetchQuestions();
        document.title = "Comprehension Worksheets for UKG | Reading Practice for Young Learners"; // Set page title
    }, []);

    return (
        <>
            <Helmet>
                <meta name="description" content='Enhance your UKG child’s reading skills with simple and engaging English comprehension exercises at Mama’s Guidance, designed to improve understanding and critical thinking.' />
            </Helmet>
            {showImage === false ? (
                <>
                    <div className="contentPart showCenter fillPreposition additionWord">
                        <h3>{questions[currentIndex]?.title}</h3>
                        <p>
                            <strong>Story:</strong>
                            <br />
                            <div dangerouslySetInnerHTML={{ __html: questions[currentIndex]?.content}}></div>
                        </p>

                        <h4>{questions[currentIndex]?.questions[currentQuestionIndex]?.questionText}</h4>
                        <div className="mb-5">
                            <IonRadioGroup
                                value={selectedOption}
                                onIonChange={(e) => handleSubmit(e.detail.value)}
                            >
                                {questions[currentIndex]?.questions[currentQuestionIndex]?.options.map((option, index) => (
                                    <IonItem
                                        className={` ${selectedOption === option
                                            ? option === questions[currentIndex]?.questions[currentQuestionIndex]?.correctAnswer
                                                ? "correct"
                                                : "errorItems"
                                            : ""
                                            }`}
                                        key={index}>
                                        <IonLabel>{option}</IonLabel>
                                        <IonRadio slot="start" value={option} />
                                    </IonItem>
                                ))}
                            </IonRadioGroup>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="contentPart showMiddle">
                        <img
                            style={{ height: "150px" }}
                            className="img-fluid"
                            src={process.env.REACT_APP_WELDONE_LINK}
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default Comprehension;
